function makeid(length) {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result;
}
           
class DiscoverySet {
constructor() {
  this.selectors = {
    addButton: '.sample-block__add, .samples-block',
    removeButton: '.sample-block__remove',
    addToCart: '.product--custom-discovery-set button[data-product-add]',
    samplePlaceholder: '.sample-placeholder',
    predefinedSetButton: '.predefined-set'
  }
  this.items = [{}, {}, {}, {}, {}]
  this.addEventListeners()
  $(".product-form__error-message").text("Please select 5 samples.");
}

addEventListeners(){
const clickDelay = 1000;

$(document).on('click', this.selectors.addButton, (e) => {
  const $btn = $(e.currentTarget);
  if ($btn.prop('disabled')) return;

  $btn.prop('disabled', true);
  this.addSampleToSet(e); 

  setTimeout(() => {
    $btn.prop('disabled', false); 
  }, clickDelay);
});

$(document).on('click', this.selectors.removeButton, (e) => {
  const $btn = $(e.currentTarget);
  if ($btn.prop('disabled')) return;

  $btn.prop('disabled', true);
  this.removeFromSampleSet(e);

  setTimeout(() => {
    $btn.prop('disabled', false);
  }, clickDelay);
});

$(document).on('click', this.selectors.samplePlaceholder, (e) => {
  const $btn = $(e.currentTarget);
  if ($btn.prop('disabled')) return;

  $btn.prop('disabled', true);
  this.scrollToList(e);

  setTimeout(() => {
    $btn.prop('disabled', false);
  }, clickDelay);
});

$(document).on('click', this.selectors.predefinedSetButton, (e) => {
  const $btn = $(e.currentTarget);
  if ($btn.prop('disabled')) return;

  $btn.prop('disabled', true);
  this.addInBulk(e);

  setTimeout(() => {
    $btn.prop('disabled', false);
  }, clickDelay);
});

}
           
async addInBulk(event) {
  $(".product-form__error-message").addClass('hidden')
  $(".predefined-set").removeClass('selected')
  $(event.currentTarget).addClass('selected')
  let ids = $(event.currentTarget).attr('data-products').split(",")
  $('.sample-block__remove').each(function() {
    $(this).trigger("click");
  })
  for(let i = 0; i < ids.length; i++) {
    $(`.sample-block__add[data-id="${ids[i]}"]`).trigger('click')
    await new Promise(resolve => setTimeout(resolve, 0.1 * 1000));
  }
  $(".product-form__error-message").removeClass('hidden');
}
           
scrollToList(event) {
  if(!$(event.currentTarget).hasClass('filled') && window.screen.width < 750) {
    $([document.documentElement, document.body]).animate({
      scrollTop: $(".product__collection-samples").offset().top - 100
    }, 100);
  }
}
addSampleToSet(event) {
  const container = $(event.currentTarget).closest(".samples-block")
  if(container.hasClass("samples-block--added")) return
  const target = $(".sample-placeholder:not(.filled)").first()
  const id = $(event.currentTarget).attr("data-id")
  const color = $(event.currentTarget).attr("data-border-color")
  const currentTotal = $(".sample-placeholder.filled").length
  const title = container.find('.sample-block__title').text();
  if(target.length) {
    const index = parseInt(target.attr('data-placeholder-index'))
    this.setImage(container, target)
    this.setTitle(title, target)
    this.setColor(color, target)
    this.setId(id, target)
    setTimeout(function() {
      target.addClass('filled');
    }, 100)
    this.items[index] = {
      title: title,
      id: id
    }

    this.updateHiddenInputs();       
    const allSelected = this.items.findIndex(e => !e.id) === -1
    container.addClass("samples-block--added")
    const selectedCount = this.items.filter(i => i.id).length
    if(allSelected) {
      $("button[data-product-add]").attr("disabled", false);
      $(".product-form__error-message-wrapper").addClass("hidden")
      $(".product-form__error-message").text("")
      $(".product-form__error-message").text("");
      this.updateProperties();
    } else {
      $(".product-form__error-message").text(`Please select ${5 - selectedCount} sample${selectedCount == 4 ? '' : 's'}.`);
    }
  }
}
           
removeFromSampleSet(event) {
  event.stopPropagation();
  let container = $(event.currentTarget).closest(".sample-placeholder")
  const id = $(event.currentTarget).attr("data-id")
  if(!container.length) {
    container = $(`.sample-placeholder [data-id="${id}"]`).closest(".sample-placeholder")
  }
  $(`.samples-block--added [data-id="${id}"]`).closest(".samples-block--added").removeClass("samples-block--added")
  container.removeClass("filled")
  const imagesToRemove = container.find("img")
  container.find('.sample-placeholder__title').text('');
  setTimeout(function() {
    imagesToRemove.remove();
  }, 1000)
  const index = parseInt(container.attr('data-placeholder-index'))
  this.items[index] = {}
  this.updateHiddenInputs();
  const selectedCount = this.items.filter(i => i.id).length
  const filledSamples = $(".sample-placeholder.filled").length;
  if (filledSamples < 5) {
    $("button[data-product-add]").attr("disabled", true);
    $(".product-form__error-message-wrapper").removeClass("hidden");
    if (5 - selectedCount == 1) {
        $(".product-form__error-message").text(`Please select ${5 - selectedCount} sample.`);
    }else{
        $(".product-form__error-message").text(`Please select ${5 - selectedCount} samples.`);
    }
  }
}
               
             
updateHiddenInputs() {
    const container = $(".discovery-hidden-inputs");
    container.empty();

    var timestamp = makeid(10);
  
    this.items.forEach((item, index) => {
      if (item.id) {
        container.append(`
          <input type="hidden" name="items[${index}][id]" data-index="${index}" value="${item.id}">
          <input type="hidden" name="items[${index}][quantity]" data-index="${index}" value="1">
          <input type="hidden" name="items[${index}][properties][_sample]" data-index="${index}" value="${timestamp}">
          <input type="hidden" name="items[${index}][properties][_index]" data-index="${index}" value="${index}">
        `);
      }
    });
    return timestamp;
  }
           
updateProperties(event, timestamp){
  const proContainer = $(".dicovery-hidden-properties");
  proContainer.empty();
  var timestamp = this.updateHiddenInputs();
  
  proContainer.append(`
  <input type="hidden" name="properties[_discovery_set]" value="${timestamp}">
  <input type="hidden" name="properties[Sample 1]" value="${this.items[0].title}">
  <input type="hidden" name="properties[Sample 2]" value="${this.items[1].title}">
  <input type="hidden" name="properties[Sample 3]" value="${this.items[2].title}">
  <input type="hidden" name="properties[Sample 4]" value="${this.items[3].title}">
  <input type="hidden" name="properties[Sample 5]" value="${this.items[4].title}">
  `);  
}

setImage(container, target) {
  const img = container.find('img').clone()
  target.find('.sample-media').append(img)
}

setTitle(title, target) {
  target.find('.sample-placeholder__title').text(title)
}

setColor(color, target) {
  target.find('.sample-block__remove').css("border-color", color)
}

setId(id, target) {
  target.find('.sample-block__remove').attr("data-id", id)
  target.attr('data-variant',id)     
}
}

document.addEventListener("DOMContentLoaded", function() {
new DiscoverySet()
$("button[data-product-add]").attr("disabled", "disabled");
});

